import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
/* Utils */
import { getLeadUid } from 'site-modules/shared/components/lead-form/utils/utils';
/* Components */
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';

export function DealerVinCardSrpNew({ leadTarget, showEmptyRating = true }) {
  const { dealer, inventory } = leadTarget;

  const dealerInfo = get(inventory, 'dealerInfo', dealer);
  const vin = get(inventory, 'vin');
  const showSubcopy =
    !!vin && inventory?.prices?.edmundsSuggestedPriceIsCompliant && inventory.prices.edmundsSuggestedPrice > 0;

  const salesOverallRating = get(dealerInfo, 'displayInfo.salesOverallRating', get(dealerInfo, 'salesRating', 0));
  const salesReviewCount = get(dealerInfo, 'displayInfo.salesReviewCount', get(dealerInfo, 'salesReviewCount', 0));

  const uid = getLeadUid(leadTarget);
  const showRating = salesOverallRating > 0 || showEmptyRating;

  return (
    <div className="size-14 text-cool-gray-40">
      <div>
        <div className="size-16 text-cool-gray-40 fw-bold mb-0_25" id={uid}>
          <span>{dealerInfo.name}</span>
        </div>

        {showRating && (
          <div className="mb-0_25">
            <RatingStars rating={salesOverallRating} className="text-primary-darker me-0_25" />
            <span>({salesReviewCount})</span>
          </div>
        )}

        {showSubcopy && (
          <div className="small fst-italic text-gray-dark">We&apos;ll show you the price you should pay.</div>
        )}
      </div>
    </div>
  );
}

DealerVinCardSrpNew.propTypes = {
  leadTarget: PropTypes.shape({
    inventory: PropTypes.shape({}),
    dealer: PropTypes.shape({}),
  }).isRequired,

  showEmptyRating: PropTypes.bool,
};
